module.exports = __webpack_public_path__ + "img/offline-experience-banner.2ed95088.jpg";